import { systemActionsConstants } from "@/store/actions";
import { _sharedReducerSystem, _sharedStateSystem } from "@/shared/store/system/reducer";

export const initialState = {
  ..._sharedStateSystem,
  showSearchPanel: false,
  showAvailableLangPanel: false,
  isShowPanelBookContents: false,
  showAdvSearchPanel: false,
  showSideMenu: false,
};

const systemReducer = (state = initialState, action) => {
  const { type, data } = action;
  switch (type) {
    case systemActionsConstants.SET_SHOW_SEARCH_PANEL:
      return { ...state, showSearchPanel: action.data };

    case systemActionsConstants.SET_SHOW_PANEL_BOOK_TRANSLATIONS:
      return { ...state, showAvailableLangPanel: action.data };

    case systemActionsConstants.SET_SHOW_PANEL_BOOK_CONTENTS:
      return { ...state, showAvailableLangPanel: false, isShowPanelBookContents: action.data };

    case systemActionsConstants.SET_SHOW_ADV_SEARCH_PANEL:
      return {
        ...state,
        showAdvSearchPanel: action.data,
        showSearchPanel: false,
        showSideMenu: false,
      };

    case systemActionsConstants.SET_SHOW_SIDE_MENU:
      return { ...state, showSideMenu: data };
    case systemActionsConstants.ACTION_HIDE_ALL:
      return {
        ...state,
        showAdvSearchPanel: false,
        showSearchPanel: false,
        showAvailableLangPanel: false,
        showSideMenu: false,
      };

    default:
      return _sharedReducerSystem(state, action);
  }
};

export default systemReducer;
